import React, { useState } from "react";
import styled from "styled-components";
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Icon from '@material-ui/core/Icon';

const Title = styled.h2`
  margin: 20px 0px;
`;

const Tip = styled.h5`
  color: #86929f;
  font-size: 1.125rem !important;
  margin: 10px 0px;
`;

const Row = styled.div`
  border-radius: 16px;
  box-shadow: 0 0 33px rgb(137 156 197 / 17%);
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  margin: 4px 0px;
  min-width: 500px;
  transition: 0.2s ease background;
  width: 100%;

  &:hover {
    background: #dfdfdf;
  }

  @media(max-width: 620px) {
    min-width: unset;
  }

  div:nth-child(1) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    span {
      font-weight: bold;
    }

    p {
      font-size: 1.125rem;
      color: #86929f;
      margin: 0;
      max-width: 240px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  div:nth-child(2) {
    display: flex;
    align-items: center;

    p {
      color: #86929f;
      margin: 0;
      font-size: 1.125rem;
    }

    span {
      color: #86929f;
      margin-top: 2px;
    }
  }
`;

const NoteTitle = styled.h2`
  margin: 0;
`;

const NoteDate = styled.h5`
  color: #86929f;
  font-size: 1.125rem;
  font-weight: bold;
  margin: 8px 0px 8px 0px;
`;

const Note = styled.div`
  border: none;
  font-family: 'DM Sans', sans-serif;
  font-size: 1rem;
  max-width: 500px;
  padding: 16px;
  white-space: pre-line;
`;

const DataRow = ({date, title, onClick}) => {
  const formatedDate = moment.utc(date).format('MMM Do')

  return (
    <Row onClick={() => onClick()}>
      <div>
        <span>{formatedDate}</span>
        <p>{title}</p>
      </div>
      <div>
        <p>View</p>
        <span style={{marginRight: '8px'}}><Icon className="material-icons">navigate_next</Icon></span>
      </div>
    </Row>
  )
}

export const NotesModal = ({open, onClose, data}) => {
  const [show, setShow] = useState(false);
  const [noteData, setNoteData] = useState('');

  return (
    <>
      <Dialog
        open={open}
        onClose={() => onClose()}
      >
        {data &&
          <DialogContent className="avn-modal-content-container">
            <Title>Notes for {data.date} check-in</Title>
            <Tip>Select a note to view</Tip>
            {data.data.map((item, id) => {
              return (
                <DataRow 
                  date={item.displayed_date}
                  title={item.title}
                  onClick={() => {setShow(true); setNoteData(item);}}
                  note={item.note}
                />
              )
            })}
          </DialogContent>
        }
        <DialogActions className='avn-modal-actions-container'>
          <button
            className="avn-modal-action"
            onClick={() => onClose()}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={show}
        onClose={() => setShow(false)}
      >
        <DialogContent className="avn-modal-content-container">
          {noteData &&
            <>
              <NoteTitle>{noteData.title}</NoteTitle>
              <NoteDate>{moment.utc(noteData.displayed_date).format('MMMM Do, YYYY')}</NoteDate>
              <Note>
                {noteData.note}
              </Note>
            </>
          }
        </DialogContent>
        <DialogActions className='avn-modal-actions-container'>
          <button
            className="avn-modal-action"
            onClick={() => setShow(false)}
          >
            Close
          </button>
        </DialogActions>
      </Dialog>
    </>
  )
}

